import { render, staticRenderFns } from "./UserAvatarWidget.vue?vue&type=template&id=8013ee64&"
import script from "./UserAvatarWidget.vue?vue&type=script&lang=js&"
export * from "./UserAvatarWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports